import { useSidebar } from "@/hooks/useSidebar";
import ClosedNavigationItem from "./ClosedNavigationItem";
import OpenNavigationItem from "./OpenNavigationItem";
import { NavigationItemProps } from "./types";
import { Path } from "@/router";
import { useSidebarContext } from "./useSidebarContext";

export default function NavigationLink<P extends Path>({ ...props }: NavigationItemProps<P>) {
  const { isSidebarOpen } = useSidebar();
  const { forceExpanded } = useSidebarContext();
  const isExpanded = forceExpanded || isSidebarOpen;
  const Component = isExpanded ? OpenNavigationItem : ClosedNavigationItem;

  return <Component {...props} />;
}
